import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { FooterModule, HeaderModule, SidebarModule } from '@coreui/angular';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AuthenticatedLayoutComponent } from './authenticated-layout.component';
@NgModule({
  imports: [CommonModule,
    SharedModule,
    RouterModule,
    FooterModule,
    HeaderModule,
    SidebarModule,
    NgScrollbarModule,
    BsDropdownModule.forRoot()
  ],
  declarations: [AuthenticatedLayoutComponent],
  exports: [AuthenticatedLayoutComponent]
})
export class AuthenticatedLayoutModule { }